import React from "react";
import { Link } from "react-router-dom";

import primaryImg from "images/primary1.svg";
import secondaryImg from "images/secondary.svg";

export default function ResourcesPage() {
  return (
    <div className="section">
      <h3 className="title is-3">教學資源庫</h3>
      <div className="content is-medium">
        <div className="columns">
          <div className="column" />
          <div className="column">
            <Link to="/primarytopics">
              <img src={primaryImg} alt="" style={{ height: "20vh" }} />
              <div>小學教材</div>
            </Link>
          </div>
          <Link to="/secondarytopics">
            <div className="column">
              <img src={secondaryImg} alt="" style={{ height: "20vh" }} />
              <div>中學教材</div>
            </div>
          </Link>
          <div className="column" />
        </div>
        <p></p>
      </div>
    </div>
  );
}
